// extracted by mini-css-extract-plugin
var _1 = "CrossLinkForm_root__94f69";
export { _1 as "root" }
